// extracted by mini-css-extract-plugin
module.exports = {"container":"CertificateList_container__vy8co"};